import React, { ReactElement } from 'react';
import { WixDesignSystemsMaskingContext } from './context';
import { maskingClassNames } from './constants';
import { WixDesignSystemsMaskingProviderProps } from './WixDesignSystemsMaskingProvider.types';

export const WixDesignSystemsMaskingProvider = ({
  children,
}: WixDesignSystemsMaskingProviderProps): ReactElement => (
  <WixDesignSystemsMaskingContext.Provider value={{ maskingClassNames }}>
    {children}
  </WixDesignSystemsMaskingContext.Provider>
);

WixDesignSystemsMaskingProvider.displayName = 'WixDesignSystemsMaskingProvider';
